var map = {
	"./appstore.png": 3635,
	"./bg-mobile.jpg": 3022,
	"./caste_code.png": 4343,
	"./dolphinlogo.png": 3098,
	"./khalti.svg": 4234,
	"./map.jpg": 5226,
	"./mavorion.png": 5726,
	"./mobileimgnew.png": 307,
	"./play.png": 3484,
	"./user.png": 4353,
	"./we_accept.png": 1487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;